import { z } from 'zod';
import { StatusEnum, StatusTypeSchema } from '../enums/status.js';

export const applicationSchema = z.object({
  id: z.coerce.number(),
  identifier: z.string(),
  name: z.string(),
  createdOn: z.coerce.date(),
  createdBy: z
    .object({
      id: z.coerce.number(),
      name: z.string(),
    })
    .nullable(),
  status: StatusTypeSchema.prefault(StatusEnum.Draft),
  icon: z.string().optional(),
});
export type Application = z.infer<typeof applicationSchema>;
